module.exports = __webpack_public_path__ + "static/media/computer_5.186ce09b.ico";